/* eslint-disable new-cap */
export default {
    methods: {
        bankOperationsToStore(item, action, storeName) {
            const payload = {
                item,
                action
            };
            this.$store.dispatch(`${storeName}/selectBankOperation`, payload);
        },
        RDOperationsToStore(item, action, storeName) {
            const payload = {
                item,
                action
            };
            this.$store.dispatch(`${storeName}/selectRDOperation`, payload);
        },
        autoSelectElements(data, storeName) {
            // console.warn('>>> AutoSelectElements');
            const { bankOperations, RDOperations } = data;
            bankOperations.forEach(item => {
                const bankOperationsList = this.$store.getters[`${storeName}/bankOperations`];
                const indexBankOperation = bankOperationsList.findIndex(x => x.uuid === item.uuid);
                if (indexBankOperation < 0) {
                    this.bankOperationsToStore(item, 'add');
                }
            });
            RDOperations.forEach(item => {
                const RDOperationsList = this.$store.getters[`${storeName}/RDOperations`];
                const indexRDOperation = RDOperationsList.findIndex(x => x.uuid === item.uuid);
                if (indexRDOperation < 0) {
                    this.RDOperationsToStore(item, 'add');
                }
            });
        },
        clearSelection(storeName) {
            this.$store.dispatch(`${storeName}/removeBankOperationsSelected`);
            this.$store.dispatch(`${storeName}/removeRDOperationsSelected`);
            this.$store.dispatch(`${storeName}/setGroupedSelected`, false);
            this.$store.dispatch(`${storeName}/setUuidGroupedSelected`, false);
            this.$store.dispatch(`${storeName}/disableGroups`, false);
            this.$store.dispatch(`${storeName}/disableAll`, false);
            this.$store.dispatch(`${storeName}/setComment`, null);
        }
    }
};
